import { useCallback, useEffect } from "react";
const addScrollBlocking = (ref, preventScrolling, stopPropagation) => {
    var _a;
    document.body.style.overflow = "hidden";
    document.body.addEventListener("touchmove", preventScrolling, {
        passive: false,
    });
    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener("touchmove", stopPropagation);
};
const removeScrollBlocking = (ref, preventScrolling, stopPropagation) => {
    var _a;
    document.body.style.overflow = "inherit";
    document.body.removeEventListener("touchmove", preventScrolling);
    (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener("touchmove", stopPropagation);
};
const useScrollBlocking = (enabled, ref) => {
    const preventScrolling = useCallback((e) => {
        e.preventDefault();
    }, []);
    const stopPropagation = useCallback((e) => {
        e.stopPropagation();
    }, []);
    useEffect(() => {
        if (enabled) {
            addScrollBlocking(ref, preventScrolling, stopPropagation);
        }
        else {
            removeScrollBlocking(ref, preventScrolling, stopPropagation);
        }
    }, [enabled, preventScrolling, stopPropagation, ref]);
};
export default useScrollBlocking;
//# sourceMappingURL=useScrollBlocking.js.map